import { render } from "./ini-kenapa-ga-bisa-batch.vue?vue&type=template&id=7ab2170e"
import script from "./ini-kenapa-ga-bisa-batch.vue?vue&type=script&lang=js"
export * from "./ini-kenapa-ga-bisa-batch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__